/* Featured jobs: render job cards from the Jobboardly XML feed.
 *
 * Markup contract (see partials/job-feed.hbs):
 *   <ul class="gh-job-feed-list" data-job-feed="https://.../jobs.xml"></ul>
 * The list is filled client-side; if the fetch fails, it stays empty and the
 * surrounding static copy / "View all jobs" link still work.
 */
(function () {
    const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    // Text of a *direct* child element (the feed nests <location> inside
    // <location_limits> too, so querySelector would be ambiguous).
    function child(node, tag) {
        for (let i = 0; i < node.children.length; i++) {
            if (node.children[i].tagName === tag) {
                return node.children[i].textContent.trim();
            }
        }
        return '';
    }

    function parse(xmlText, now) {
        const doc = new DOMParser().parseFromString(xmlText, 'application/xml');
        if (doc.getElementsByTagName('parsererror').length) {
            return [];
        }

        const nowMs = (now || new Date()).getTime();
        const jobs = [];

        Array.prototype.forEach.call(doc.getElementsByTagName('job'), function (node) {
            const closes = child(node, 'expires_at');
            const closesMs = Date.parse(closes);
            if (!isNaN(closesMs) && closesMs < nowMs) {
                return;
            }

            const publishedMs = Date.parse(child(node, 'published_at'));

            jobs.push({
                title: child(node, 'title'),
                company: child(node, 'company_name'),
                location: child(node, 'location').split(',')[0].trim(),
                url: child(node, 'url'),
                closes: closes,
                sticky: child(node, 'sticky') === 'true',
                published: isNaN(publishedMs) ? 0 : publishedMs
            });
        });

        jobs.sort(function (a, b) {
            if (a.sticky !== b.sticky) {
                return a.sticky ? -1 : 1;
            }
            return b.published - a.published;
        });

        return jobs;
    }

    // "2026-09-09T23:59:59-05:00" -> "9 Sep". Uses the calendar date as
    // written in the feed rather than converting to the viewer's timezone.
    function formatCloses(iso) {
        const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || '');
        if (!m) {
            return '';
        }
        return parseInt(m[3], 10) + ' ' + MONTHS[parseInt(m[2], 10) - 1];
    }

    function el(tag, className, text) {
        const node = document.createElement(tag);
        node.className = className;
        if (text !== undefined) {
            node.textContent = text;
        }
        return node;
    }

    // The feed is third-party input: only ever link to http(s) URLs.
    function safeUrl(value) {
        try {
            const url = new URL(value);
            return (url.protocol === 'https:' || url.protocol === 'http:') ? url.href : '';
        } catch (e) {
            return '';
        }
    }

    function render(jobs, list) {
        list.textContent = '';

        jobs.forEach(function (job) {
            const card = el('li', 'gh-job-card');

            const href = safeUrl(job.url);
            const title = el(href ? 'a' : 'span', 'gh-job-card-title', job.title);
            if (href) {
                title.href = href;
            }
            card.appendChild(title);

            if (job.company) {
                card.appendChild(el('p', 'gh-job-card-company', job.company));
            }

            const closes = formatCloses(job.closes);
            const meta = [job.location, closes ? 'closes ' + closes : '']
                .filter(Boolean)
                .join(', ');
            if (meta) {
                card.appendChild(el('p', 'gh-job-card-meta', meta.charAt(0).toUpperCase() + meta.slice(1)));
            }

            list.appendChild(card);
        });
    }

    // Show the up/down arrows only when there are more jobs than fit.
    function syncScrollControls(list, buttons) {
        const scrollable = list.scrollHeight > list.clientHeight + 1;
        buttons.forEach(function (button) {
            button.hidden = !scrollable;
        });
    }

    // Nudge the list by one card (plus the grid gap) up (-1) or down (1).
    function scrollStep(list, direction) {
        const card = list.firstElementChild;
        if (!card) {
            return;
        }
        const gap = parseFloat(getComputedStyle(list).rowGap) || 0;
        list.scrollBy({top: direction * (card.getBoundingClientRect().height + gap), behavior: 'smooth'});
    }

    // Fill one list: render the cards, wire its arrows and keep them in sync.
    function mount(jobs, list) {
        render(jobs, list);

        const feed = list.closest('.gh-job-feed');
        if (!feed) {
            return;
        }
        feed.classList.add('has-jobs');

        const buttons = Array.prototype.slice.call(feed.querySelectorAll('[data-job-feed-scroll]'));
        const sync = function () {
            syncScrollControls(list, buttons);
        };
        buttons.forEach(function (button) {
            button.addEventListener('click', function () {
                scrollStep(list, parseInt(button.getAttribute('data-job-feed-scroll'), 10) || 1);
            });
        });
        sync();
        window.addEventListener('resize', sync);
    }

    // The block can appear more than once on a page (e.g. the home page has
    // a copy for wide and one for narrow screens): fetch each feed URL once
    // and fill every list that uses it.
    function init() {
        const lists = Array.prototype.slice.call(document.querySelectorAll('[data-job-feed]'));
        if (!lists.length || !window.fetch || !window.DOMParser) {
            return;
        }

        const listsByUrl = {};
        lists.forEach(function (list) {
            const url = list.getAttribute('data-job-feed');
            listsByUrl[url] = (listsByUrl[url] || []).concat(list);
        });

        Object.keys(listsByUrl).forEach(function (url) {
            fetch(url)
                .then(function (response) {
                    if (!response.ok) {
                        throw new Error('Job feed responded ' + response.status);
                    }
                    return response.text();
                })
                .then(function (xmlText) {
                    const jobs = parse(xmlText);
                    if (jobs.length) {
                        listsByUrl[url].forEach(function (list) {
                            mount(jobs, list);
                        });
                    }
                })
                .catch(function () {
                    // Leave the static fallback in place.
                });
        });
    }

    window.htfpJobFeed = {
        parse: parse,
        formatCloses: formatCloses,
        render: render,
        syncScrollControls: syncScrollControls,
        scrollStep: scrollStep,
        init: init
    };
    init();
})();
